import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';
import { IoMdCheckmarkCircle } from "react-icons/io";

import hero from '../../../assets/gourNoidaExt/hero.jpeg'
import logo from '../../../assets/gourNoidaExt/logo.png'

import ph1 from '../../../assets/gourNoidaExt/ph1.jpeg'
import ph2 from '../../../assets/gourNoidaExt/ph2.webp'
import ph3 from '../../../assets/gourNoidaExt/ph3.jpg'
import ph4 from '../../../assets/gourNoidaExt/ph4.webp'
import ph5 from '../../../assets/gourNoidaExt/ph5.jpg'

import li1 from '../../../assets/gourNoidaExt/li1.jpg'
import li2 from '../../../assets/gourNoidaExt/li2.jpg'
import li3 from '../../../assets/gourNoidaExt/li3.webp'
import li4 from '../../../assets/gourNoidaExt/li4.webp'
import li5 from '../../../assets/gourNoidaExt/li5.webp'

import { ImageModal } from '../../common/ImageModal';
import { ConnectForm } from '../../common/ConnectForm';


const GourNoidaExtension = () => {
    const location = useLocation();
    const [openImgModal, setOpenImgModal] = useState(false);

    const [selectedImgIndex, setSelectedImgIndex] = useState(null);
    const [activeImageType, setActiveImageType] = useState(null);
    const [currentIndex, setCurrentIndex] = useState(0);

    const ameneties = [
        { id: 0, img: ph1, title: "Standlone Towers" },
        { id: 1, img: ph2, title: "Luxury Water Club" },
        { id: 2, img: ph3, title: "Luxury Landscape" },
        { id: 3, img: ph4, title: "High Street Commerical" },
        { id: 4, img: ph5, title: "Luxury Art Tower Facade" },
    ]

    const interiors = [li1, li2, li3, li4, li5]

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);


    const handleOpenModal = (index, type) => {
        setSelectedImgIndex(index);
        setActiveImageType(type);
        setOpenImgModal(true);
    }

    return (
        <div className="w-full min-h-screen bg-gray-100">
            <div
                className="w-full h-[700px] bg-cover bg-center transition-all duration-500"
                style={{ backgroundImage: `url('${hero}')` }}
            ></div>

            <div className="w-full p-2 flex justify-center items-center overflow-hidden transition-all duration-500">
                <div className="w-[90%] sm:w-[80%] md:w-[70%] lg:w-[60%] xl:w-[50%] max-h-[300px]">
                    <img src={logo} alt="logo" className="w-full h-full object-contain rounded-lg" />
                </div>
            </div>
            <div class="flex flex-col md:flex-row px-2.5 gap-4">
                <div class="w-full md:w-2/3 flex flex-col gap-4">
                    <div className="">
                        <div className="max-w-5xl mx-auto p-6">
                            <p className="text-md text-gray-700 mb-4 text-justify font-semibold">
                                The Gaur Group has unveiled its latest residential marvel in Noida Extension, setting a new
                                benchmark for luxury and modern living. This new project, located in the heart of Techzone 4,
                                Greater Noida West, is designed to cater to the aspirations of contemporary homeowners seeking
                                comfort, convenience, and elegance. </p>

                            <section className="p-2 md:p-3 bg-gray-100 text-gray-900">
                                <h2 className="text-2xl md:text-3xl font-bold my-2">Introduction</h2>
                                <div className="max-w-4xl mx-auto">
                                    <p className="text-md text-gray-700 my-1 text-justify">
                                        Welcome to the most iconic launch in Greater Noida West by the Gaur Group, a visionary developer
                                        with over 30 years of excellence in redefining luxury living. This project is a masterpiece of
                                        architectural brilliance, offering a lifestyle that combines sophistication with practicality. </p>
                                </div>
                            </section>



                            <section className="p-4 md:p-6 bg-gray-100 text-gray-900 rounded-lg">
                                <h2 className="text-2xl md:text-3xl font-bold my-2">Project Highlights :</h2>
                                <div className="max-w-4xl mx-auto mb-6">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">Expansive Development:</h3>
                                    <p className="text-md text-gray-700 text-justify">
                                        Spread across 11 acres, this project features king-size residences
                                        that redefine space and luxury.
                                    </p>
                                </div>
                                <div className="max-w-4xl mx-auto mb-6">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">Premium Apartments:</h3>
                                    <p className="text-md text-gray-700 text-justify">
                                        Offering 3/4 BHK apartments with well-appointed layouts, ensuring
                                        maximum ventilation and natural light.
                                    </p>
                                </div>
                                <div className="max-w-4xl mx-auto mb-4">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">World-Class Amenities:</h3>
                                    <p className="text-md text-gray-700 text-justify">
                                        Residents can enjoy an infinity pool, spa, wellness retreat,
                                        clubhouse, landscaped gardens, and children's play areas.
                                    </p>
                                </div>
                                <div className="max-w-4xl mx-auto mb-4">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">Eco-Friendly Features:</h3>
                                    <p className="text-md text-gray-700 text-justify">
                                        The project incorporates rainwater harvesting and sustainable
                                        landscaping.
                                    </p>
                                </div>
                            </section>


                            <section className="p-2 md:p-3 bg-gray-100 text-gray-900">
                                <h2 className="text-2xl md:text-3xl font-bold">Location Advantages</h2>
                                <div className="max-w-4xl mx-auto">
                                    <p className="text-md text-gray-700 my-1 text-justify">
                                        Strategically located in Techzone 4, the project offers seamless connectivity:
                                    </p>
                                    <ul className="space-y-1 text-left max-w-2xl my-2 font-sm">
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            <div>
                                                2 km from the proposed metro station.                                             </div>
                                        </li>
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            <div> 10 minutes from Sector 32 Metro Station. </div>
                                        </li>
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            <div>
                                                6 km from Fortis Hospital.                                             </div>
                                        </li>
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            <div>
                                                15 minutes from Sector 18 Market.                                            </div>
                                        </li>
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            <div>
                                                Close to premium schools like Lotus Valley International School and Aster Public School.                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </section>


                            <section className="p-4 md:p-6 bg-gray-100 text-gray-900 rounded-lg">
                                <h2 className="text-2xl md:text-3xl font-bold my-2">Lifestyle Benefits :</h2>
                                <p className="text-md text-gray-700 text-justify">
                                    This project is more than just a home; it's a lifestyle designed for those who seek elegance, comfort,
                                    and convenience. With its proximity to medical units, premium hotels, malls, and restaurants, it
                                    ensures that every need is met within a short distance.
                                </p>
                            </section>


                            <section className="p-2 md:p-3 bg-gray-100 text-gray-900">
                                <h2 className="text-2xl md:text-3xl font-bold">Why Choose This Project?
                                </h2>
                                <div className="max-w-4xl mx-auto">
                                    <ul className="space-y-1 text-left max-w-2xl my-2 font-sm">
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            <div>
                                                Designed by globally acclaimed architects, blending artistry with innovation.
                                            </div>
                                        </li>
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            <div>
                                                Located near Gaur Saundaryam, one of the most luxurious societies in Greater Noida West.                                                </div>
                                        </li>
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            <div>
                                                Offers a perfect balance of modern architecture and high-end living.
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </section>


                            <section className="p-2 md:p-3 bg-gray-100 text-gray-900">
                                <div className="max-w-4xl mx-auto">
                                    <p className="text-md text-gray-700 my-1 text-justify">
                                        This new launch by the Gaur Group is not just a residential project; it's a gateway to a life of
                                        unparalleled luxury and convenience. Be part of a community that values quality, innovation, and
                                        sustainability.
                                    </p>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
                <ConnectForm />
            </div>
            <div className="max-w-7xl mx-auto p-4">
                <h2 className="text-2xl font-semibold text-gray-800 my-4">
                    Projects Highlights
                </h2>
                {openImgModal && activeImageType === "ameneties" && (
                    <ImageModal
                        images={ameneties.map((item) => item.img)}
                        openImg={openImgModal}
                        selectedImgIndex={selectedImgIndex}
                        onClose={() => setOpenImgModal(false)}
                    />
                )}

                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
                    {ameneties.map((data, index) => (
                        <div key={index}
                            onClick={() => handleOpenModal(index, "ameneties")}
                            className="w-full max-w-sm mx-auto rounded-md shadow-md overflow-hidden bg-white">
                            <div className="relative">
                                <img
                                    src={data.img}
                                    alt={data.title}
                                    className="w-full h-56 object-cover transition-transform duration-300 transform hover:scale-105"
                                />
                            </div>
                            <div className="px-5 py-3">
                                <h3 className="text-gray-700 font-semibold">{data.title}</h3>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <h2 className="text-2xl font-semibold text-gray-800 m-4">
                Luxury  Insights
            </h2>
            {openImgModal && activeImageType === "interiors" && (
                <ImageModal
                    images={interiors.map((item) => item.img)}
                    openImg={openImgModal}
                    selectedImgIndex={selectedImgIndex}
                    onClose={() => setOpenImgModal(false)}
                />
            )}

            <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 p-4">
                {interiors.map((data, index) => (
                    <div
                        key={index}
                        onClick={() => handleOpenModal(index, "interiors")}
                        className="w-full mx-auto rounded-md shadow-md overflow-hidden bg-white"
                    >
                        <img
                            src={data}
                            alt="ATS"
                            className="w-full h-full rounded-md shadow-md overflow-hidden bg-white object-cover transition-transform duration-300 transform hover:scale-105"
                        />
                    </div>
                ))}
            </div>
        </div>
    )
}
export default GourNoidaExtension